import React, { Component } from 'react';
import Box from '../ui/Box';
import { Dialog } from 'material-ui';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Select, { Async } from 'react-select'

//providers
import DataService from '../../services/DataService'; var ds = DataService;
import Helper from '../../services/Helper'; var help = Helper;

export default class NewRemote extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: this.props.details ? this.props.details.name : "",
      type: this.props.details ? this.props.details.type : "",
      brand: this.props.details ? this.props.details.stb_provider_id || this.props.details.brand : "",
      remote_types: [
        { "value": "AV Receiver", label: "AV Receiver" },
        { "value": "Projector", label: "Projector" },
        { "value": "Disc Player", label: "Disc Player" },
        { "value": "TV", label: "TV" },
        { "value": "Media Streamer", label: "Media Streamer" },
        { "value": "Set Top Box", label: "Set Top Box" },
        { "value": "Air Conditioner", label: "Air Conditioner" }
      ],
      all_devices: [],
      all_brands: this.props.details && this.props.details.type == "Set Top Box" ? [{
        label: this.props.details ? this.props.details.brand : "",
        value: this.props.details ? this.props.details.stb_provider_id || this.props.details.brand : ""
      }] : [],
      test_codesets: [],
      test_codeset: this.props.details ? this.props.details.remote_codeset : "",
      paired_ud: this.props.details ? this.props.details.paired_ud : "",
      pre_room_id: this.props.room_main_id,
      stb_provider_name: this.props.details ? this.props.details.brand : "",
      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    }
    if (this.props.details) {
      this.getBrands(this.props.details.type).then(() => {
        this.getTestCodeSets(this.state.brand, this.state.test_codeset);
      });
    }
  }

  componentDidMount() {
    this.getAllDevices();
  }

  getAllDevices() {
    ds.getDevicesInRoom(this.state.pre_room_id, data => {
      if (data && data.length) {
        for (let i of data) {
          i.label = i.device_name;
          i.value = i._id;
        }
      }
      this.setState({
        all_devices: data
      })
    }, err => {

    })
  }

  closeDialog() {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    })

  }

  triggerIr(key) {
    let kd_id = ""
    for (let i of this.state.all_devices) {
      if (i._id == this.state.paired_ud) {
        kd_id = i.kd_id;
        break;
      }
    }
    let keyHere = null;
    if (this.state.type == "Set Top Box") {
      for (let i of this.state.test_codesets) {
        if (this.state.test_codeset == i._id) {
          keyHere = i.keys[0];
          break;
        }
      }
    }

    let obj = help.getIrPayload(key, this.state.test_codesets, this.state.test_codeset, this.state.type, kd_id, this.state.paired_ud, keyHere);

    ds.postTriggerIr(obj,
      (data) => {
        console.log(data);
      },
      (error) => {
        console.log(error);
      });
  }

  createRemote(e) {
    e.preventDefault();
    if (!this.state.name) {
      this.setState({
        dialog: {
          open: true,
          head: 'Name is required',
          body: "Fill the 'name' to give remote a name",
          actions: [
            <FlatButton
              label="Okay"
              primary
              onClick={this.closeDialog.bind(this)}
            />
          ]
        }
      })
      return;
    }
    if (!this.state.brand
      || !this.state.type || this.state.paired_ud == -1 || !this.state.test_codeset) {
      this.setState({
        dialog: {
          open: true,
          head: 'Invalid',
          body: 'All Fields are mandatory',
          actions: [
            <FlatButton
              label="Okay"
              primary
              onClick={this.closeDialog.bind(this)}
            />
          ]
        }
      })
    }
    else {
      let payload;
      payload = {
        room: this.state.pre_room_id,
        type: this.state.type,
        remote_codeset: this.state.test_codeset,
        name: this.state.name,
        paired_ud: this.state.paired_ud
      };
      if (this.state.type == 'Set Top Box') {
        payload.provider_id = this.state.brand;
        payload.brand = this.state.stb_provider_name;
      }
      else {
        payload.brand = this.state.brand;
      }
      if (this.props.details) {
        ds.postEditRemote({ ...payload, id: this.props.details._id }, data => {
          let evt = new CustomEvent('updateRemotesTable', { detail: true });
          window.dispatchEvent(evt);
          this.props.unMountMe();
        }, err => {

        })
      }
      else {
        ds.postCreateRemote(payload, data => {
          let evt = new CustomEvent('updateRemotesTable', { detail: true });
          window.dispatchEvent(evt);
          this.setState({
            name: "",
            type: "",
            brand: "",
            test_buttons: {},
            test_codeset: "",
            test_codesets: []
          })
        }, err => {

        })
      }
    }

  }

  handleChanges(e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  getBrands(value) {
    return new Promise((resolve, reject) => {
      ds.getSearchBrands(value, data => {
        let brands = data[0].brand_codeset;
        let brands_arr = [];
        for (let i in brands) {
          brands_arr.push({
            label: i,
            value: i
          })
        }
        return this.setState({
          all_brands: brands_arr
        }, () => {
          console.log(this.state);
          return resolve();
        })
      }, err => {
        return reject(err);
      })
    });
  }

  getTestCodeSets(brand, set_test_buttons = 0) {
    ds.getTestCodesets(this.state.type, brand, data => {
      let test_codesets = [];
      for (let i of data) {
        test_codesets.push({
          label: i.name,
          value: i._id,
          ...i
        })
      }
      this.setState({
        test_codesets: test_codesets
      })
      if (set_test_buttons) {
        this.setTestButtons(set_test_buttons)
      }
    }, err => {

    })
  }

  getProviders(value) {
    return new Promise((go, die) => {
      ds.getSearchProviders(value, data => {
        let brands_arr = [];
        for (let i of data) {
          brands_arr.push({
            label: i.name,
            value: i.id
          })
        }
        this.setState({
          all_brands: brands_arr
        })
        go({ options: brands_arr });
      }, err => {

      })
    });
  }
  setTestButtons(test_codeset) {
    let buttons;
    for (let i of this.state.test_codesets) {
      if (i.value == test_codeset && this.state.type == "Air Conditioner") {
        this.refineForType3(i);
        buttons = i.keys;
        break;
      }
      else if (i.value == test_codeset) {
        if (this.state.type == "Set Top Box") {
          buttons = i.keys[0];
          break;
        }
        buttons = i.keys;
        break;
      }
    }
    this.setState({
      test_buttons: buttons
    });
  }

  refineForType3(i) {
    if (i.type == 3 && i.constraints && i.constraints.modes) {
      i.keys = [];
      i.keys.push({
        func: "POWER ON",
        mode_set: i.constraints.modes[0],
        power_set: "ON",
        temp_set: i.constraints.min_temp,
        fan_set: i.constraints.fan_speeds ? "FAN_" + i.constraints.fan_speeds[0] : ""
      });
      i.keys.push({
        func: "POWER OFF",
        mode_set: i.constraints.modes[0],
        power_set: "OFF",
        temp_set: i.constraints.min_temp
      });
      if (i.constraints.modes.indexOf("COOL") != -1) {
        i.keys.push({
          func: "MODE COOL",
          mode_set: "COOL",
          power_set: "ON",
          temp_set: i.constraints.min_temp,
          fan_set: i.constraints.fan_speeds ? "FAN_" + i.constraints.fan_speeds[0] : ""
        });
      }
      if (i.constraints.modes.indexOf("HEAT") != -1) {
        i.keys.push({
          func: "MODE HEAT",
          mode_set: "HEAT",
          power_set: "ON",
          temp_set: i.constraints.min_temp,
          fan_set: i.constraints.fan_speeds ? "FAN_" + i.constraints.fan_speeds[0] : ""
        });
      }

    }
  }


  render() {
    return (
      <Box header='New Remote'>
        <Dialog
          title={this.state.dialog.head}
          autoScrollBodyContent={true}
          actions={this.state.dialog.actions}
          modal={false}
          open={this.state.dialog.open}
          onRequestClose={this.closeDialog.bind(this)}
        >
          {this.state.dialog.body || 'NA'}
        </Dialog>

        <div className="col-sm-12">
          <form className="smart-form " onSubmit={this.createRemote.bind(this)}>
            <fieldset>
              <section>
                <Select
                  id="type"
                  ref={(ref) => { this.select = ref; }}
                  onBlurResetsInput={false}
                  onSelectResetsInput={false}
                  autoFocus
                  options={this.state.remote_types}
                  simpleValue
                  clearable={true}
                  name="type"
                  disabled={false}
                  value={this.state.type}
                  onChange={(newValue) => {
                    this.setState({
                      type: newValue,
                      brand: "",
                      test_buttons: {},
                      test_codeset: "",
                      test_codesets: []
                    })
                    if (newValue == 'Set Top Box') {

                    }
                    else {
                      this.getBrands(newValue);
                    }

                  }}
                  searchable={true}
                  placeholder="Remote Type"
                  style={{ marginTop: "15px" }}
                />
              </section>

              <section>
                <TextField
                  floatingLabelText="Name"
                  name="name"
                  className="w-100"
                  value={this.state.name}
                  onChange={this.handleChanges.bind(this)}
                />
              </section>

              {
                this.state.type ? <div>
                  <section>
                    <Select
                      id="paired_ud"
                      ref={(ref) => { this.select2 = ref; }}
                      onBlurResetsInput={false}
                      onSelectResetsInput={false}
                      autoFocus
                      options={this.state.all_devices}
                      simpleValue
                      clearable={true}
                      name="paired_ud"
                      disabled={false}
                      value={this.state.paired_ud}
                      onChange={(newValue) => {
                        this.setState({
                          paired_ud: newValue,
                        })
                      }}
                      searchable={true}
                      placeholder="Device To Pair"
                      style={{ marginTop: "15px" }}
                    />
                  </section>
                  <section>
                    {this.state.type == "Set Top Box" ? <Async
                      id="brand"
                      ref={(ref) => { this.select2 = ref; }}
                      onBlurResetsInput={false}
                      onSelectResetsInput={false}
                      options={this.state.all_brands}
                      simpleValue
                      clearable={true}
                      name="brand"
                      disabled={false}
                      loadOptions={this.getProviders.bind(this)}
                      value={this.state.brand}
                      onChange={(newValue) => {
                        let stb_provider_name = "";
                        for (let i of this.state.all_brands) {
                          if (i.value == newValue) {
                            stb_provider_name = i.label;
                          }
                        }
                        this.setState({
                          brand: newValue,
                          stb_provider_name
                        })
                        this.getTestCodeSets(newValue);
                      }}
                      searchable={true}
                      placeholder="Select Brand"
                      style={{ marginTop: "15px" }}
                    /> :
                      <Select
                        id="brand"
                        ref={(ref) => { this.select3 = ref; }}
                        onBlurResetsInput={false}
                        onSelectResetsInput={false}
                        options={this.state.all_brands}
                        simpleValue
                        clearable={true}
                        name="brand"
                        disabled={false}
                        value={this.state.brand}
                        onChange={(newValue) => {
                          this.setState({
                            brand: newValue
                          })
                          this.getTestCodeSets(newValue);
                        }}
                        searchable={true}
                        placeholder="Select Brand"
                        style={{ marginTop: "15px" }}
                      />
                    }

                  </section>
                  {
                    this.state.paired_ud && this.state.brand && this.state.test_codesets && this.state.test_codesets.length ? <div>
                      <section>
                        <Select
                          id="test_codeset"
                          ref={(ref) => { this.select6 = ref; }}
                          onBlurResetsInput={false}
                          onSelectResetsInput={false}
                          autoFocus
                          options={this.state.test_codesets}
                          simpleValue
                          clearable={true}
                          name="test_codeset"
                          disabled={false}
                          value={this.state.test_codeset}
                          onChange={(newValue) => {
                            this.setState({
                              test_codeset: newValue,
                            })
                            this.setTestButtons(newValue);

                          }}
                          searchable={true}
                          placeholder="Select Codeset"
                          style={{ marginTop: "15px" }}
                        />
                      </section>
                      {
                        this.state.test_buttons && Object.keys(this.state.test_buttons) && Object.keys(this.state.test_buttons).length ?
                          <section style={{ marginTop: "2vw", marginBottom: "1vw" }}> Test Buttons</section> : null}

                      {
                        this.state.test_buttons && Object.keys(this.state.test_buttons) && Object.keys(this.state.test_buttons).length && this.state.type != 'Air Conditioner' ?
                          Object.keys(this.state.test_buttons).map(
                            (obj, ind) => {
                              return <FlatButton
                                label={obj}
                                onClick={this.triggerIr.bind(this, obj)}
                                primary
                              />

                            }
                          ) : this.state.type == 'Air Conditioner' && this.state.test_buttons && this.state.test_buttons.length ?
                            this.state.test_buttons.map(
                              (obj) => {
                                return <FlatButton
                                  label={obj.func}
                                  onClick={this.triggerIr.bind(this, obj)}
                                  primary
                                />

                              }
                            )
                            : null
                      }
                    </div> : null
                  }
                </div> : null
              }

            </fieldset>

            <div className="mt-4vw align-right">
              <RaisedButton
                label="Save"
                primary
                type="submit"
              />
              <span className="space"></span>
              {
                this.props.details ?
                  <FlatButton
                    label="Cancel"
                    primary
                    onClick={this.props.unMountMe.bind(this, false)}
                    type="button"
                  /> : null
              }
            </div>
          </form>

        </div>
      </Box>)
  }
}


// WEBPACK FOOTER //
// ./components/remotes/NewRemote.js